var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ToTop",on:{"click":_vm.backToTop}},[_c('img',{attrs:{"src":"https://oss.sbooip.com/static/www/pc/assets/images/top.png","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }